"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var router_1 = require("@reach/router");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var Paragraph_1 = require("../../atoms/Paragraph");

exports.ClickList = function (_a) {
  var id = _a.id,
      className = _a.className,
      children = _a.children;
  return React.createElement("div", {
    id: id,
    className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "clicklist", className])
  }, children);
};

exports.ClickList.Row = function (_a) {
  var id = _a.id,
      className = _a.className,
      title = _a.title,
      helperText = _a.helperText,
      onClick = _a.onClick,
      href = _a.href,
      to = _a.to;
  var Component = href ? "a" : to ? router_1.Link : "div";
  return React.createElement(Component, {
    id: id,
    className: utils_1.DomUtils.cleanupClassNames([className, CSSPrefix_1.lsgPre + "clicklist-row", (onClick || href) && CSSPrefix_1.lsgPre + "clicklist-row-clickable"]),
    onClick: onClick,
    href: href,
    tabIndex: href || onClick ? 0 : -1
  }, React.createElement(Paragraph_1.Paragraph, null, React.createElement("strong", null, title)), helperText && React.createElement(Paragraph_1.Paragraph, {
    size: Paragraph_1.Paragraph.Sizes.HELPER
  }, helperText), React.createElement(Icon_1.Icon, {
    name: Icon_1.Icon.Names.interaction_arrows_chevronRight
  }));
};

exports.ClickList.displayName = "ClickList";
exports.ClickList.Row.displayName = "ClickList.Row";